<template lang="pug">
  .modal.is-active
    .modal-background(@click="$emit('close')")
    .modal-content
      .is-4by3
        youtube(v-if="isYoutube" :video-id="videoEmbed" :player-vars="{ autoplay: 1 }" :player-width="'100%'" @ended="$emit('close')")
        .vimeo(v-else-if="isVimeo")
          .vimeo-video
            .plyr__video-embed#player
              iframe(:src="iframeSrc" allowfullscreen allowtransparency allow="autoplay")
        div.iframe-video(v-if="!isYoutube && !isVimeo" :class="{'relative': relative}")
          video(controls autoplay ref="video")
            source(:src="iframeSrc" :type="videoType")
      button.modal-close.is-large(@click="$emit('close')" aria-label="close")
</template>
<script>
import Vue from 'vue'
import VueYouTubeEmbed from 'vue-youtube-embed'
import { directive as onAway } from 'vue-clickaway'
import Plyr from 'plyr'

Vue.use(VueYouTubeEmbed)
/* eslint-disable no-new */
export default {
  name: 'VideoModal',
  directives: {
    onAway
  },
  props: {
    videoEmbed: {
      default: ''
    },
    clickAway: {
      default: true
    },
    show: {
      default: false
    },
    isYoutube: {
      default: true
    },
    isVimeo: {
      default: false
    },
    iframeSrc: {
      default: ''
    },
    videoType: {
      default: ''
    },
    relative: {
      default: false
    }
  },
  methods: {
    away () {
      if (this.clickAway) this.$emit('close')
    }
  },
  mounted () {
    if (this.isVimeo) {
      new Plyr('#player', {
        autoplay: true,
        volume: 1
      })
    }
  }
}
</script>

<style lang="scss">
  .vimeo{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    &-video{
      width: 100%;
    }
  }
  .iframe-video{
    width: 100%;
    padding-top: 56.25%;
    &.relative{
      padding: 0;
      height: 100%;
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      video, iframe{
        position: relative;
        width: auto!important;
        height: auto!important;
        max-height: 100%;
      }
    }
    video, iframe{
      position: absolute;
      left: 0px;
      top: 0px;
      width: 100%!important;
      height: 100%!important;
    }
  }
  @media screen and (max-width: 1087px) {

  }
  @media screen and (max-width: 480px) {
    .modal {
      .modal-content {
        margin-top: 50px;
      }
    }
  }

</style>

<style lang="sass" src="plyr/src/sass/plyr.scss"></style>



// WEBPACK FOOTER //
// src/components/video-modal/index.vue